export function isFullSentence(text: string): boolean {
    return text.endsWith('.') || text.endsWith('?') || text.endsWith('!');
}

export function toSnakeCase(str: string): string {
    return str
        .replace(/([a-z])([A-Z])/g, '$1_$2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
        .toLowerCase();
}
